<template>
  <div
    class="tw-bg-white tw-flex tw-flex-col tw-flex tw-flex-col"
    data-walkthrough-id="sidepane-container"
    data-testid="sidepane-container"
  >
    <sidepane-communication :is-body-scrollable="true" />
  </div>
</template>
<script>
import { mapGetters, mapState } from 'vuex'
import { mapState as mapPiniaState, mapActions as mapPiniaActions } from 'pinia'
import SidepaneCommunication from '@app/application/communication/sections/communication/components/sidepane-communication'
import registerSidepagePageVisitMixin from '@app/shared/vue/mixins/register-sidepane-page-visit'

import { useDrawer } from '@app/shared/pinia/drawer'

export default {
  name: 'SfSidepane',
  components: {
    'sidepane-communication': SidepaneCommunication,
  },
  mixins: [registerSidepagePageVisitMixin],

  props: {
    ledgerLabel: {
      type: String,
      required: true,
    },
    ownerId: {
      type: Number,
      required: true,
    },
    ownerType: {
      type: String,
      required: true,
    },
  },

  data() {
    return {
      sidepane: false, // true = open, false = closed
    }
  },

  computed: {
    ...mapGetters(['contextType', 'contextId', 'ledgerId']),
    ...mapState({
      fetchingCommunicationsStatus: (state) =>
        state.ui.fetchingCommunicationsStatus,
    }),
    ...mapPiniaState(useDrawer, ['isRightDrawerOpen']),
  },

  created() {
    window.eventHub.$on('openSidepane', this.effectiveOpenDrawer)
  },

  beforeUnmount() {
    window.eventHub.$off('openSidepane', this.effectiveOpenDrawer)
  },

  methods: {
    ...mapPiniaActions(useDrawer, ['openRightDrawer']),
    effectiveOpenDrawer() {
      this.openRightDrawer('communication')
    },
  },
}
</script>
